export const getCookie = (name) => {
  if (!window?.document) return null;

  const matches = window.document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
  ));

  return matches ? decodeURIComponent(matches[1]) : undefined;
};
